module.exports = {
    NORMAL: {
        value: 'NORMAL',
        label: 'Normal'
    },
    MATRIX: {
        value: 'MATRIX',
        label: 'Matrix'
    }
};